import { Outlet } from "react-router-dom";
import { Layout, theme } from "antd";

import { SIDEBAR_WIDTH } from "@components/Constants";
import { useOrganizations } from "@components/Organization";
import { useLayoutTopOffset, ReleaseAlert } from "@components/Page";

import Sidebar from "./Sidebar";
import { MANAGER_MENU_ITEMS } from "./Sidebar/helpers/menuItems";
import { SecondFactorAlert } from "../../backstage/index.js";


const ConsoleManagerLayout = () => {
  const { token } = theme.useToken();
  const { colorBgContainer } = token;

  const organizations = useOrganizations();
  const layoutTopOffset = useLayoutTopOffset();

  const layoutProps = {
    style: {
      marginLeft: SIDEBAR_WIDTH,
      background: colorBgContainer,
    },
  };

  const context = {
    organizations,
    layoutTopOffset,
  };

  return (
    <>
      <Sidebar items={MANAGER_MENU_ITEMS} />

      <Layout {...layoutProps}>
        <ReleaseAlert />
        <SecondFactorAlert />

        <Layout.Content>
          <Outlet context={context} />
        </Layout.Content>
      </Layout>
    </>
  );
};

export default ConsoleManagerLayout;
